"use client"
import * as React from 'react'
import {getLatestThreeBlogs} from '../blogs/wordpress'
import styles from '../blogs/styles.module.css'
import parse from 'html-react-parser'
import Link from 'next/link'
import Image from 'next/image'
import classes from './styles.module.css'
import {Blog} from 'types/blogs'
import Tag from '../tag'

const RecommendedBlogs = ({id}: {id: string}) => {
  const [blogs, setBlogs] = React.useState<Blog[] | undefined>([])

  React.useEffect(() => {
    const getBlogs = async () => {
      try {
        let blogs = await getLatestThreeBlogs({page_number: 1})
        if (blogs?.length) {
          blogs = blogs?.filter(blog => blog.id !== id)
        }
        setBlogs(blogs?.slice(-3))
      } catch (error) {
        console.log({error})
      }
    }
    getBlogs()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div style={{position: 'relative'}}>
      <div className={classes.nextBlogTitle}> What to read next</div>
      <div className={styles.container}>
        <div className={styles.blogContainer}>
          {blogs?.map((blog, index) => (
            <Link href={`/blogs/${blog.slug}`} key={index} className={styles.blog}>
              <div className={styles.image}>
                <Image
                  priority
                  src={blog?.jetpack_featured_media_url}
                  alt="blog"
                  width="1000"
                  height="1000"
                  style={{borderTopLeftRadius: '20px'}}
                />
              </div>
              <div className={classes.recommendedBlogs}>
                <div className={classes.tags}>
                  {((blog?._embedded['wp:term'] && blog?._embedded['wp:term'][0]) || []).map(
                    (tag: {slug: string; name: string}) =>
                      tag.name !== 'Recommended' ? (
                        <Tag key={tag?.slug} text={tag.name} slug={tag?.slug} />
                      ) : null,
                  )}
                </div>
                <p className={styles.title} style={{color: 'black'}}>
                  {parse(blog.title.rendered)}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default RecommendedBlogs
